
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { CommonStudyCardUIData } from '@xt/client/entities/my-v2/types.d'
import { Bind, Debounce } from 'lodash-decorators'

const randomColors = ['#CBC3C6', '#C5CAC7', '#B8B6A2']

@Observer
@Component({
  components: { HeaderImage, LazyImg }
})
export default class StudyCard extends Vue {
  @Prop({ required: true }) item: CommonStudyCardUIData

  // 对于没有图片的内容，展示一个随机色块
  randomBgColor: string = ''

  get showLike() {
    return ['dairy'].includes(this.item.type)
  }

  get PageStore() {
    return this.$store.$myV2.Study
  }

  compactImageSize(originWidth, originHeight) {
    const limitWidth = 235
    const shouldHeigth = Math.floor((limitWidth * originHeight) / originWidth)

    return [limitWidth, shouldHeigth]
  }

  getImageHeight(originWidth, originHeight) {
    return Math.max(100, Math.min(324, this.compactImageSize(originWidth, originHeight)[1]))
  }

  getImageURL(url, originWidth, originHeight) {
    const limitWidth = 235
    const limitHeight = 324
    const minHeight = 100
    const [, shouldHeigth] = this.compactImageSize(originWidth, originHeight)

    if (shouldHeigth > limitHeight) {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(limitHeight * 2), true)
    } else if (100 < shouldHeigth && shouldHeigth <= limitHeight) {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(shouldHeigth * 2))
      // 兼容过宽图片，缩放至可视窗口的问题
    } else {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(minHeight * 2), true)
    }
  }

  @Debounce(400, { leading: true, trailing: false })
  @Bind()
  hanldeClickLike() {
    if (this.item.like === true) {
      this.$message.error('你已经点过赞了')
      return
    }

    this.PageStore.onLike(this.item)
  }

  created() {
    this.randomBgColor = randomColors[Math.floor(Math.random() * randomColors.length)]
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
